import React from "react";
import { TopMenu } from "../top-menus/top-menu";
import { useDashboardContext } from "../../contexts/dashboard-context";
import { useSelectedZone } from "../../hooks/useSelection";
import { useZoneDepth } from "../../hooks/use-zone-depth";
import { Tooltip } from "../tooltip/tooltip";
import { labels } from "./labels";
import { useLabels } from "../../hooks/useLabels";

export function ZoneDepthDropdown({
	open,
	onOpenChange,
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}) {
	const dashboard = useDashboardContext();
	const selectedZone = useSelectedZone();
	const { enableForward, enableBackward } = useZoneDepth();

	const [[textPositionText, bringToFrontText, sendToBackText]] = useLabels([
		labels.textPositionTooltip,
		labels.bringToFrontTooltip,
		labels.sendToBackTooltip,
	]);

	return (
		<TopMenu.Dropdown
			disabled={!enableForward && !enableBackward}
			iconName="bring-to-front"
			toolTipText={textPositionText}
			open={open}
			onOpenChange={onOpenChange}
		>
			<Tooltip text={bringToFrontText}>
				<TopMenu.Icon
					iconName="forward"
					disabled={!enableForward}
					onClick={() => dashboard.sendZoneForwardOrBackward(1, selectedZone)}
				/>
			</Tooltip>
			<Tooltip text={sendToBackText}>
				<TopMenu.Icon
					iconName="backward"
					disabled={!enableBackward}
					onClick={() => dashboard.sendZoneForwardOrBackward(-1, selectedZone)}
				/>
			</Tooltip>
		</TopMenu.Dropdown>
	);
}
